"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Footer = function () {
    return react_1.default.createElement(react_1.default.Fragment, null,
        "\u00A9 ",
        new Date().getFullYear(),
        " antegma GmbH - Hootsuite Integration is powered by ACCALLI/O Cloud");
};
exports.default = Footer;
//# sourceMappingURL=index.js.map